
import { Component, Prop, Watch } from 'vue-property-decorator';

import { SuppliersApi } from '@/api/SuppliersApi';

import { MetaInfo } from 'vue-meta';
import { SupplierResponse } from '@/interfaces/Suppliers';
import BaseEditablePage from '@/components/BaseEditablePage.vue';
import { isEmptyValue } from '@/config/functions';

@Component({
   methods: { isEmptyValue },
   metaInfo(): MetaInfo {
      return {
         // @ts-ignore
         title: this.model?.o_name,
      };
   },
   components: {
      ObjectForm: () => import('./_Form.vue'),
      ObjectFiles: () => import('@/components/ObjectFiles.vue'),
   },
})
export default class View extends BaseEditablePage {
   @Prop({ type: [Number, String], default: 0 }) id!: number | string;

   model: SupplierResponse | null = null;

   activities_fields: any[] = [];

   mounted() {
      this.getOrder();

      this.activities_fields = [
         {
            key: 'o_act_color',
            label: '',
            thAttr: {
               style: 'width: 43px;',
            },
            formatter: (value: string) => (isEmptyValue(value) ? this.default_colors['o_act_color'] : `#${value}`),
         },
         {
            key: 'o_num',
            label: 'Num',
            sortable: true,
            thAttr: {
               style: 'width: 150px; text-align: left !important; padding-left: 0.5rem !important;',
            },
         },
         {
            key: 'o_name',
            label: 'Name',
            sortable: true,
            thAttr: {
               style: 'text-align: left !important; padding-left: 0.5rem !important;',
            },
         },
      ];
   }

   getOrder() {
      if (this.id <= 0) {
         return;
      }

      this.$store.commit('showLoading');
      SuppliersApi.get(this.id)
         .then(supplier => {
            this.model = supplier;
         })
         .then(() => {
            this.$store.dispatch('get_all');
         })
         .finally(() => {
            this.$store.commit('hideLoading');
         });
   }

   @Watch('id')
   changeOrderId() {
      this.getOrder();
   }
}
